class SizeQuickAdd extends HTMLElement {
  connectedCallback() {
    this._form = this.querySelector('form');
    this._variantInput = this.querySelector('.size-quick-add__variant-id');
    this._status = this.querySelector('.size-quick-add__status');
    this._buttons = this.querySelectorAll('.size-quick-add__btn');

    this._buttons.forEach(btn => {
      btn.addEventListener('mouseenter', () => this._onEnter(btn));
      btn.addEventListener('mouseleave', () => this._onLeave());
      btn.addEventListener('click', () => this._onClick(btn));
    });
  }

  _onEnter(btn) {
    const available = btn.dataset.available === 'true';
    const preorder = btn.dataset.preorder === 'true';
    const tracks = btn.dataset.tracksInventory === 'true';
    const qty = parseInt(btn.dataset.inventory, 10);

    if (!available) {
      this._status.textContent = 'Out of stock';
    } else if (preorder) {
      this._status.textContent = 'On pre-order';
    } else if (tracks && qty > 0 && qty < 10) {
      this._status.textContent = `Only ${qty} left`;
    } else {
      this._status.textContent = 'Quick add';
    }
  }

  _onLeave() {
    this._status.textContent = '';
  }

  _onClick(btn) {
    if (btn.dataset.available !== 'true') return;
    this._variantInput.value = btn.dataset.variantId;
    this._form.requestSubmit();
  }
}

if (!window.customElements.get('size-quick-add')) {
  window.customElements.define('size-quick-add', SizeQuickAdd);
}


/* ── Sticky bar size select ──────────────────────────────────────────────── */

(function () {
  function initStickyBarSelect() {
    const picker = document.querySelector('.sticky-bar__size-picker');
    if (!picker) return;

    const select = picker.querySelector('.sticky-bar__select');
    const stickyBar = picker.closest('.product-sticky-bar');
    const formId = picker.dataset.formId;
    const optionPosition = parseInt(picker.dataset.optionPosition, 10);
    const optionName = `option${optionPosition}`;

    // Sync sticky select → main form radio
    select.addEventListener('change', () => {
      const value = select.value;
      if (!value) return;

      // Find matching radio in the main form's variant picker
      const radio = document.querySelector(
        `input[type="radio"][name="${optionName}"][value="${CSS.escape(value)}"]`
      );
      if (radio) radio.click();

      stickyBar.classList.add('size-chosen');
    });

    // Sync main form → sticky select (when user picks size on main page)
    document.addEventListener('change', (e) => {
      const input = e.target;
      if (input.type !== 'radio' || input.name !== optionName) return;
      if (input.value && select.value !== input.value) {
        select.value = input.value;
      }
      stickyBar.classList.add('size-chosen');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBarSelect);
  } else {
    initStickyBarSelect();
  }
})();
